// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list } from "./operations.js";
export type { StorageTaskAssignmentsInstancesReportListOptionalParams } from "./options.js";
